import { render, staticRenderFns } from "./appr-logging.vue?vue&type=template&id=60e815e4&scoped=true"
import script from "./appr-logging.vue?vue&type=script&lang=js"
export * from "./appr-logging.vue?vue&type=script&lang=js"
import style0 from "./appr-logging.vue?vue&type=style&index=0&id=60e815e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e815e4",
  null
  
)

export default component.exports